import { Button, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import { faCamera, faSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import CustomModal from 'src/components/custom_components/CustomModal/CustomModal';

import { AutoConnectCameraStatus } from 'src/models/CameraMode.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

type WarnNoConnectedCameraModalProps = {
  isVisible: boolean;
};

export default function WarnNoConnectedCameraModal({
  isVisible,
}: WarnNoConnectedCameraModalProps) {
  const history = useHistory();

  const gotoSettings = () => {
    history.push('/settings');
  };

  const { tPages } = useUiTranslation();
  const { autoConnectCameraStatus } = useRemoteBoundStore();

  return (
    <CustomModal show={isVisible} size="lg">
      <Modal.Body className="m-auto">
        <div className="p-5 ps-0 text-center">
          <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon={faCamera} size="4x" className="ms-2" />
            {autoConnectCameraStatus === AutoConnectCameraStatus.FAILED && (
              <FontAwesomeIcon
                icon={faSlash}
                size="4x"
                className="text-muted"
              />
            )}
          </span>
        </div>

        <p className="text-center lead">
          {autoConnectCameraStatus === AutoConnectCameraStatus.FAILED
            ? tPages('newExam.noCameraConnected.title')
            : `${tPages('settings.cameraModes.cameraConnection.connecting')}...`}
        </p>

        {autoConnectCameraStatus === AutoConnectCameraStatus.FAILED && (
          <p className="text-center">
            {tPages('newExam.noCameraConnected.desc')}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="primary" onClick={gotoSettings}>
          {tPages('newExam.noCameraConnected.buttonText')}
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
}
